module.exports = __webpack_public_path__ + "img/banner3.1d0fd766.png";